/*
 * 전화번호 포맷터. 구 String.prototype.phoneString / phoneHyphenString 대체.
 * 레거시 getter 는 String 객체 위에서 동작했으므로 인자는 문자열로 강제한다.
 */

/** 구 phoneString — 자릿수 기반 하이픈 포맷 (02 지역번호 케이스 포함) */
export const formatPhone = (value: string | null | undefined): string | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }
  const raw = String(value)
  if (raw.startsWith('02') && (raw.length === 9 || raw.length === 10)) {
    return raw.replace(/(\d{2})(\d{3,4})(\d{4})/, '$1-$2-$3')
  }
  if (!raw.startsWith('02') && (raw.length === 10 || raw.length === 11)) {
    return raw.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3')
  }
  return raw
}

/** 구 phoneHyphenString — 숫자만 남기고 길이 구간별 하이픈. '010-0000-0000' 은 undefined (레거시 quirk 유지) */
export const formatPhoneHyphen = (value: string | null | undefined): string | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }
  const digits = String(value).replace(/[^0-9]/g, '')
  let result: string
  if (digits.length < 4) {
    result = digits
  } else if (digits.length < 7) {
    result = digits.replace(/(\d{3})(\d{1,4})/, '$1-$2')
  } else if (digits.length < 11) {
    result = digits.replace(/(\d{3})(\d{3})(\d{1,4})/, '$1-$2-$3')
  } else {
    result = digits.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3')
  }
  if (result === '010-0000-0000') {
    return undefined
  }
  return result
}
